(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/calculator-area-parallelogram
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @overview Calculates the area of a parallelogram (rectangle, square, rhombus).
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("calculator-area-parallelogram") === undefined) {
    class CalculatorAreaParallelogram extends HTMLElement {
        constructor(){
            super();
            this.inputWidth = this.querySelector("[data-calculator-area-parallelogram-width]");
            this.inputLength = this.querySelector("[data-calculator-area-parallelogram-length]");
            this.inputTotal = this.querySelector("[data-calculator-area-parallelogram-total]");
            if (!this.inputWidth || !this.inputLength || !this.inputTotal) return;
            this.inputWidth.addEventListener("input", this.calculateArea.bind(this), false);
            this.inputLength.addEventListener("input", this.calculateArea.bind(this), false);
        }
        calculateArea() {
            this.updateTotal(this.inputLength.valueAsNumber * this.inputWidth.valueAsNumber);
        }
        updateTotal(total) {
            if (isNaN(total)) return false;
            this.inputTotal.value = total;
            this.inputTotal.dispatchEvent(new Event("input"));
        }
    }
    customElements.define("calculator-area-parallelogram", CalculatorAreaParallelogram);
}



})();
